var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam Stok Tutarı',"data":_vm.numberConverter(_vm.stockDetailData.leftAmount,'TRY'),"description":'Tüm Zamanlar',"loading":_vm.stockDetailDataLoading,"route":"/management/detailed-reports"}})
}
var staticRenderFns = []

export { render, staticRenderFns }